import { SharedContainer } from './../../shared.container';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-vervendo-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css', './footer.component.scss']
})
export class FooterComponent implements OnInit {

  adminUrl = 'https://${environment.adminUrl}';
  appUrlState: string;

  constructor(protected sharedContainer: SharedContainer, public router: Router, private route: ActivatedRoute,
    private angulartics2: Angulartics2) {
  }

  ngOnInit() {
    this.appUrlState = location.pathname;
    const footer = <HTMLElement>document.getElementById('vvdo-footer');
    this.router.events.subscribe(changes => {
      if (!this.isMobile() && (this.router.url.includes('/application-form') || this.router.url.includes('/my-dashboard'))) {
        footer.classList.add('application-form-footer');
      } else {
        footer.classList.remove('application-form-footer');
      }
    });
  }

  scrollToTrustUs() {
    const el = document.getElementById('trust-text');
    el.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToCustomerReviews() {
    const el = document.getElementById('customer-reviews');
    el.scrollIntoView({ behavior: 'smooth' });
  }

  isLoading() {
    return this.sharedContainer.isLoading$;
  }

  isLoggedIn() {
    return this.sharedContainer.isLoggedIn$;
  }

  goToLoginPage(intent: string) {
    this.router.navigate(['login-page'], { queryParams: { intent: intent } });
  }

  isMobile() {

    const w = window.innerWidth;
    if (w < 992) {
      return true;
    }

    return false;
  }

  checkRouting() {
    if (this.router.url.includes('/property') || this.router.url.includes('/booking')) {
      // console.log('Debugging');
      return true;
    }

    return false;
  }

  goToPropertyReg() {
    this.router.navigate(['application-form/en']);
  }

  angulartics2Track(action: string) {
    this.angulartics2.eventTrack.next({ action: action });
  }

}
